module.exports = __webpack_public_path__ + "static/media/house7.e344060b.png";